import { gql } from "@apollo/client";

export const CREATE_PROJECT = gql`
  mutation createProjectData($input: createProjectDataInput) {
    createProjectData(input: $input) {
      projectId
    }
  }
`;

export const GET_ALL_PROJECTS = gql`
  query allProjects {
    allProjects {
      projectId
      projectName
      startDate
      endDate
      createdOn
      projectBudget
      assetsAllocated
      assetsBudget
      operationMargin
      calendar
      projectHistory
      rolesAndSkills
      assetsBudget
      taskdetails {
        taskId
        taskType
      }

      roleData {
        roles
        roleId
        userData {
          userId
          firstName
          lastName
          compensation {
            effectivePeriod
            effectiveDate
            ctc
          }
        }
      }
    }
  }
`;


export const UPDATE_PROJECT = gql`
  mutation updateProjectData($input: updateProjectDataInput) {
    updateProjectData(input: $input)
  }
`;

export const UPDATE_EMPLOYEE_PROJECTTEAM = gql`
  mutation updateEmployeeProjectTeam($input: updateEmployeeProjectTeamInput) {
    updateEmployeeProjectTeam(input: $input)
  }
`;
export const GET_PROJECTBY_ID = gql`
  query organizationProject($projectId: String!) {
    organizationProject(projectId: $projectId) {
      projectId
      projectName
      startDate
      employeeName
      endDate
      projectBudget
      calendar
      operationMargin
      assetsBudget
      rolesAndSkills
      assetsAllocated
      projectHistory
      taskdetails {
        taskType
      }
      skillDetails {
        projectId
        skillType
        skillid
      }
      roleData {
        roles
        roleId
        hierarchy
        userData {
          firstName
          lastName
        }
      }
      projectAccessConfig {
        viewer
        owner
        projectId
      }
      empDt {
        Id
        startDateBy
        endDateBy
        reportTo
        budgetconsumption
        role
        skills
        history
        employeeName
        isDeleted
        userDetails {
          firstName
          lastName
        }
        rolenames {
          roleId
          roles
          userData {
            firstName
            lastName
          }
        }
        assetDetails {
          allocatedTo
          assetValue
          assetbuildTo
          projectId
        }
      }
    }
  }
`;
export const DELETE_PROJECT = gql`
  mutation deleteProjectData($projectId: String) {
    deleteProjectData(projectId: $projectId)
  }
`;
export const GET_PROJECT_ROLES = gql`
  query projectRoles($projectId: String) {
    projectRole(projectId: $projectId) {
      roleId
      roles
      hierarchy
    }
  }
`;

export const UPDATE_PROJECTROLE = gql`
  mutation updateProjectRole($input: [updateProjectRoleInput]) {
    updateProjectRole(input: $input)
  }
`;
export const CREATE_EMPLOYEE_PROJECT = gql`
  mutation createEmployeeProjectRole($input: [createEmployeeProjectRoleInput]) {
    createEmployeeProjectRole(input: $input) {
      projectId
    }
  }
`;





export const UPDATE_TASK = gql`
  mutation UpdateTask($input: updateTaskInput) {
    updateTask(input: $input)
  }
`;











export const CREATE_BOARD = gql`
  mutation createBoard($input: createBoardInput) {
    createBoard(input: $input) {
      Id
    }
  }
`;
























export const GET_EMPLOYEE_PROJECT_ROLES = gql`
  query employeeProjectRoles($userId: String) {
    employeeProjectRoles(userId: $userId) {
      projectId
      startDateBy
      endDateBy
      employeeName
      reportTo
      projDetails {
        projectName
        projectId
        startDate
        endDate
        taskdetails {
          taskId
          taskType
          projectId
        }
        roleData {
          hierarchy
          roleId
          roles
          userData {
            firstName
            lastName
            userId
          }
        }
      }
    }
  }
`;

export const GET_PROJECT_BY_REPORTS = gql`
  query projectByReports(
    $projectId: String
    $fromDate: String
    $endDate: String
    $location: String
  ) {
    projectByReports(
      projectId: $projectId
      fromDate: $fromDate
      endDate: $endDate
      location: $location
    ) {
      projectId
      projectName
      startDate
      endDate
      employeeDetails {
        startDateBy
        endDateBy
        employeeName
        reportTo
        userDetails {
          firstName
          lastName
        }
        leaves {
          lop
          reason
          consumedLeaves
        }
      }
    }
  }
`;

export const GET_TASKS_BY_USER = gql`
  query taskByuser($assignTask: String) {
    taskByuser(assignTask: $assignTask) {
      title
      description
      Id
      startDate
      status
      endDate
      boardId
      assignTask
      isBoolean
      userDetails {
        firstName
      }
      createdByUserDetails {
        firstName
        lastName
      }
    }
  }
`;

export const GET_ALL_EMPLOYEE_PROJECT_ROLES = gql`
  query GetemployeeProjectRoles($projectId: String) {
    getemployeeProjectRoles(projectId: $projectId) {
      projectId
      employeeName
    }
  }
`;

export const DELETE_PROJECT_SELECTED_EMPLOYEE = gql`
  mutation deleteProjectSelectedEmployee(
    $projectId: String
    $employeeName: String
  ) {
    deleteProjectSelectedEmployee(
      projectId: $projectId
      employeeName: $employeeName
    )
  }
`;

export const DELETE_PROJECT_ROLE = gql`
  mutation deleteProjectRole($projectId: String, $roleId: Int) {
    deleteProjectRole(projectId: $projectId, roleId: $roleId)
  }
`;

export const GET_PROJECT_SKILLS = gql`
  query getprojectSkills($projectId: String) {
    getprojectSkills(projectId: $projectId) {
      skillid
      skillType
    }
  }
`;
export const GET_PROJECT_SUGGESTED_EMPLOYEES = gql`
  query GetProjectSuggestedEmployees($input: projectSuggestedEmployeesInput) {
    getProjectSuggestedEmployees(input: $input) {
      role
      selectedEmployees {
        userId
        firstName
        lastName
        imageUrl
      }
    }
  }
`;
export const GET_PROJECTS_BY_USER_ID = gql`
  query getProjectsByUserId($userId: String) {
    getProjectsByUserId(userId: $userId) {
      projectId
      projectName
      startDate
      endDate
      createdOn
      projectBudget
      assetsAllocated
      assetsBudget
      operationMargin
      calendar
      projectHistory
      rolesAndSkills
      assetsBudget
      taskdetails {
        taskId
        taskType
      }
      projectAccessConfig {
        viewer
        owner
        projectId
      }
      roleData {
        roles
        roleId
        userData {
          userId
          firstName
          lastName
          compensation {
            effectivePeriod
            effectiveDate
            ctc
          }
        }
      }
    }
  }
`;
